module.exports = __webpack_public_path__ + "static/media/platz-t1.9dce244d.svg";